module.exports = __webpack_public_path__ + "static/media/RP-88.8cc4365a.pdf";